module.exports = __webpack_public_path__ + "img/full4-min.7d505254.png";